import { useMemo } from "react";

import { isWithinDateRange } from "../utils/activityHelpers";
import { parseISO } from "date-fns";
import { ActivityFilters } from "../types/ActivityList.types";
import { WorkItemList } from "../store/services/timelineApiRTK";
import { WORK_ITEM_CATEGORIES, WorkItemCategory } from "../utils/workItemUtils";

export const useActivityFilters = (
  workItems: WorkItemList[],
  filters: ActivityFilters,
  favorites: number[]
) => {
  return useMemo(() => {
    const filtered = workItems.filter((activity) => {
      // Sökfiltrering
      if (filters.search) {
        const lowerCaseQuery = filters.search.toLowerCase();
        const matchesSearch =
          activity.Name.toLowerCase().includes(lowerCaseQuery) ||
          activity.Customer?.Name?.toLowerCase().includes(lowerCaseQuery) ||
          activity.Description?.toLowerCase().includes(lowerCaseQuery) ||
          activity.Team?.Name?.toLowerCase().includes(lowerCaseQuery);
        if (!matchesSearch) return false;
      }

      // Datumfiltrering
      if (!isWithinDateRange(activity, filters.dateFilter)) {
        return false;
      }

      // Kategorifiltrering
      if (filters.category === "all") {
        return true;
      } else if (filters.category === "favorites") {
        return favorites.includes(activity.Id);
      } else {
        return (
          WORK_ITEM_CATEGORIES[filters.category as WorkItemCategory]?.includes(
            activity.Type
          ) || false
        );
      }
    });

    // Sortera efter schemalagt datum
    return filtered.sort((a, b) => {
      if (!a.ScheduledTo && !b.ScheduledTo) return 0;
      if (!a.ScheduledTo) return 1;
      if (!b.ScheduledTo) return -1;

      try {
        const dateA = parseISO(a.ScheduledTo);
        const dateB = parseISO(b.ScheduledTo);
        return dateA.getTime() - dateB.getTime();
      } catch {
        return 0;
      }
    });
  }, [workItems, filters, favorites]);
};
